import * as React from "react";

const About = () => {
    return (
      <ol className="references">
         <li>
            World Health Organization. HIV/AIDS. Updated July 2021. Accessed August 19, 2021.&nbsp;  
            <a target="_blank" className="d-inline-block" href="https://www.who.int/data/gho/data/themes/hiv-aids">https://www.who.int/data/gho/data/themes/hiv-aids</a>
          </li>
         <li>
            Tseng A, Seet J, Phillips EJ. The evolution of three decades of antiretroviral therapy: challenges, triumphs 
            and the promise of the future. <br className="d-none d-xl-block" /><em>Br J Clin Pharmacol.</em> 2015;79(2):182-194.
          </li>
         <li>
            National Institutes of Health. HIV/AIDS. Updated October 7, 2015. Accessed March 16, 2021. 
            <a target="_blank" className="d-inline-block" href="https://www.nih.gov/about-nih/what-we-do/nih-turning-discovery-into-health/hiv/aids">https://www.nih.gov/about-nih/what-we-do/nih-turning-discovery-into-health/hiv/aids</a>
          </li>
         <li>
            Wawrzyniak AJ, Rodriguez AE, Falcon AE, et al. The Association of Individual and Systemic 
            Barriers to Optimal Medical Care in People Living with HIV/AIDS (PLWHA) in Miami-Dade County.&nbsp; 
            <em>J Acquir Immune Defic Syndr.</em> 2015;69(0 1):S63-S72.
          </li>
         <li>
            Centers for Disease Control and Prevention. Defining health disparities. Updated September 4, 2020. 
            Accessed July 29, 2021. <a target="_blank" className="d-inline-block" href="https://www.cdc.gov/nchhstp/healthdisparities/default.htm">https://www.cdc.gov/nchhstp/healthdisparities/default.htm</a>
          </li>
      </ol>
    )
  }

export default About;